export interface BandRoute { bandId: string | null; joining: boolean }
export function bandRoute(path: string): BandRoute | null {
  if (/^\/bands\/?$/.test(path)) return { bandId: null, joining: false };
  if (/^\/bands\/join\/?$/.test(path)) return { bandId: null, joining: true };
  const match = /^\/bands\/([A-Za-z0-9_-]{1,100})\/?$/.exec(path);
  return match ? { bandId: match[1], joining: false } : null;
}
export function openBand(bandId?: string): void {
  history.pushState(null, "", bandId ? `/bands/${encodeURIComponent(bandId)}` : "/bands");
  window.dispatchEvent(new PopStateEvent("popstate"));
}
export function youtubeId(value: string): string | null {
  const trimmed = value.trim();
  if (/^[A-Za-z0-9_-]{11}$/.test(trimmed)) return trimmed;
  try {
    const url = new URL(trimmed);
    if (!/^https?:$/.test(url.protocol)) return null;
    let id: string | null = null;
    if (url.hostname === "youtu.be") id = url.pathname.split("/")[1];
    if (["youtube.com", "www.youtube.com", "m.youtube.com", "music.youtube.com"].includes(url.hostname)) {
      id = url.pathname === "/watch" ? url.searchParams.get("v") : /^\/(shorts|embed)\/([^/]+)/.exec(url.pathname)?.[2] ?? null;
    }
    return id && /^[A-Za-z0-9_-]{11}$/.test(id) ? id : null;
  } catch { return null; }
}
export function noteSeconds(value: string): number | null {
  if (!value.trim()) return null;
  const match = /^(\d{1,4})(?::([0-5]\d))?$/.exec(value.trim());
  if (!match) throw new Error("구간은 0:45처럼 분:초 또는 초 단위로 입력해 주세요.");
  const n = match[2] === undefined ? Number(match[1]) : Number(match[1]) * 60 + Number(match[2]);
  if (n > 7200) throw new Error("구간은 120분 이내로 입력해 주세요.");
  return n;
}
